export const FORMULA_TIPS_COMMON: Record<string, string> = {
  previsto: "Previsto (ha) = soma das áreas planejadas.",
  realizado: "Realizado (ha) = soma das áreas executadas.",
  restante: "A realizar (ha) = previsto − realizado.",
  pct: "% Execução = realizado ÷ previsto.",
  dataInicial: "Data inicial = primeira data apontada de execução no PIMS.",
  projecao:
    "Projeção de término = data atual + (área a realizar ÷ ritmo diário). Ritmo zero: sem projeção.",
  status:
    "Status só para em andamento (0% < execução < 100%). Em Dia / Em Atenção / Atrasada conforme projeção vs data final planejada.",
};

/** Header: Meta / Ritmo / Meta ajustada não fixam fórmula única. */
export const FORMULA_TIPS_HEADER_TIPO =
  "A fórmula depende do tipo (calendarizada ou não calendarizada). Ver tooltip na linha da classe ou no detalhe do drilldown.";

export const FORMULA_TIPS_CLASSE_CAL = {
  meta: "Calendarizada | Classe: meta diária (ha) = área planejada da classe ÷ quantidade de datas programadas (consolidado).",
  ritmo:
    "Calendarizada | Classe: ritmo diário (ha) = (área realizada até ontem + área prevista restante) ÷ (dias efetivos até ontem + dias programados restantes), considerando toda a classe.",
  metaAdj:
    "Calendarizada | Classe: meta diária ajustada (ha) = área a realizar da classe ÷ datas programadas restantes (consolidado).",
};

export const FORMULA_TIPS_CLASSE_NAO_CAL = {
  meta: "Não calendarizada | Classe: meta diária (ha) = área planejada da classe ÷ quantidade de dias da janela (consolidado).",
  ritmo:
    "Não calendarizada | Classe: ritmo diário (ha) = área executada da classe ÷ dias efetivos (consolidado).",
  metaAdj:
    "Não calendarizada | Classe: meta diária ajustada (ha) = área a realizar da classe ÷ dias restantes da janela (consolidado).",
};

export const FORMULA_TIPS_DETALHE_CAL = {
  meta: "Passada | Meta diária (ha) = área planejada da passada ÷ quantidade de datas programadas da passada.",
  ritmo:
    "Passada | Ritmo diário (ha) = (área realizada até ontem + área prevista restante) ÷ (dias efetivos até ontem + dias programados restantes), na passada.",
  metaAdj:
    "Passada | Meta diária ajustada (ha) = área a realizar da passada ÷ datas programadas restantes da passada.",
};

export const FORMULA_TIPS_DETALHE_NAO = {
  meta: "Janela | Meta diária (ha) = área planejada da janela ÷ quantidade de dias da janela.",
  ritmo: "Janela | Ritmo diário (ha) = área executada da janela ÷ dias efetivos da janela.",
  metaAdj:
    "Janela | Meta diária ajustada (ha) = área a realizar da janela ÷ dias restantes da janela.",
};

export type FormulaTipCol = "meta" | "ritmo" | "metaAdj";

export function getMetricFormulaTip(
  col: FormulaTipCol,
  operacaoCalendarizada: boolean,
  isParent: boolean
): string {
  if (isParent) {
    const pack = operacaoCalendarizada
      ? FORMULA_TIPS_CLASSE_CAL
      : FORMULA_TIPS_CLASSE_NAO_CAL;
    return pack[col];
  }
  const pack = operacaoCalendarizada
    ? FORMULA_TIPS_DETALHE_CAL
    : FORMULA_TIPS_DETALHE_NAO;
  return pack[col];
}

/** Tip no nome da operação (Anexo 1 / Anexo 2 do protótipo). */
export function getOperacaoNomeTip(
  isParent: boolean,
  operacaoCalendarizada: boolean
): string {
  if (isParent) {
    return operacaoCalendarizada
      ? "Classe calendarizada (consolidado). Passe o mouse nas colunas para as fórmulas deste tipo."
      : "Classe não calendarizada (consolidado). Passe o mouse nas colunas para as fórmulas deste tipo.";
  }
  return operacaoCalendarizada
    ? "Detalhe por passada (drilldown)."
    : "Detalhe por janela (drilldown).";
}
